import { render } from "./DistributionMap.vue?vue&type=template&id=b51d0bce&scoped=true"
import script from "./DistributionMap.vue?vue&type=script&lang=js"
export * from "./DistributionMap.vue?vue&type=script&lang=js"

import "./DistributionMap.vue?vue&type=style&index=0&id=b51d0bce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51d0bce"]])

export default __exports__